import React from 'react';
import { Box, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../dum';
import { IOrderQuotation } from '../../order-quotation-form';
import { formatFloat } from '../../../../../../../../helpers';

// Read-only money readout for the Productos tab. `products_total` is the stored
// subtotal (kept in the form so it validates); IVA and total are derived from
// it and the IVA-visible flag, mirroring the backend's tax/total ResolveFields
// (16% when require_tax, 0% otherwise).
export function QuotationTotals() {
    const subtotalName: keyof IOrderQuotation = 'products_total';
    const requireTaxName: keyof IOrderQuotation = 'require_tax';

    const subtotalValue = useWatch({ name: subtotalName }) as number;
    const requireTax = useWatch({ name: requireTaxName }) as boolean;

    const subtotal = Number(subtotalValue) || 0;
    const tax = requireTax ? Math.round(subtotal * 0.16 * 100) / 100 : 0;
    const total = Math.round((subtotal + tax) * 100) / 100;

    return (
        <Box>
            <RhNumberField
                name={subtotalName}
                label={'Subtotal'}
                disabled
            />
            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    justifyContent: 'flex-end',
                    mt: 1,
                }}
            >
                {requireTax ? (
                    <Typography variant={'body2'} color={'text.secondary'}>
                        IVA (16%): {formatFloat(tax)}
                    </Typography>
                ) : null}
                <Typography variant={'body2'}>
                    <b>Total: {formatFloat(total)}</b>
                </Typography>
            </Box>
        </Box>
    );
}
